import Api from "../utils/api";
import getConfig from "../config/index";
import "@iptv/base-network";
import { getQuery } from "../utils/url";
import store from "../store";
const { ticket, uuid } = store.state.userInfo;
/**
 * 获取接口请求通用参数
 * @returns Object
 */
const getCommonParams = () => {
  const params = {
    ticket,
    uuid,
    ts: getQuery("ts") || "", // 预览页面接口的参数
  };
  return params;
};

const baseNetwork = window.createBaseNetwork({
  platform: "web",
  baseURL: getConfig().baseURL,
  timeout: 10000,
});

class service {
  /**
   * @desc 查询活动信息
   * @param params
   */
  getActivityInfo(params) {
    // post请求，第2个参数作为body参数
    return baseNetwork
      .post(Api.activityInfo, { ...getCommonParams(), ...params })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err || "";
      });
  }

  /**
   * @desc 微信h5,分享签名接口
   * @param url
   */
  getSignWxh5Iptv() {
    const params = {
      url: window.location.href.split("#")[0],
    };
    return baseNetwork.jsonp(Api.getSignWxSdk, params).then(
      (res) => {
        return res.data;
      },
      (err) => {
        return err || "";
      },
    );
  }

  /**
   * @desc 获取芒果卡身份
   * @param params
   */
  getIsHit(params) {
    // post请求，第2个参数作为body参数
    return baseNetwork
      .post(Api.getIsHit, { ...getCommonParams(), ...params })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err || "";
      });
  }

  /**
   * @desc 查询超级现场活动信息
   * @param params
   */
  getSuperInfo(params) {
    // post请求，第2个参数作为body参数
    return baseNetwork
      .post(Api.getSuperInfo, { ...getCommonParams(), ...params })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err || "";
      });
  }

  /**
   * @desc 查询中奖列表
   * @param params
   */
  getSuperList(params) {
    // post请求，第2个参数作为body参数
    return baseNetwork
      .post(Api.getSuperList, { ...getCommonParams(), ...params })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err || "";
      });
  }

  /**
   * @desc 领取新用户礼包接口
   * @param params
   */
  getClaim(params) {
    // post请求，第2个参数作为body参数
    return baseNetwork
      .post(Api.getClaim, { ...getCommonParams(), ...params })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err || "";
      });
  }

  /**
   * @desc 参加活动接口
   * @param params
   */
  setJoinSuper(params) {
    // post请求，第2个参数作为body参数
    return baseNetwork
      .post(Api.setJoinSuper, { ...getCommonParams(), ...params })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err || "";
      });
  }

  /**
   * @desc 身份证认证接口
   * @param params
   */
  setIdentity(params) {
    // post请求，第2个参数作为body参数
    return baseNetwork
      .post(Api.setIdentity, { ...getCommonParams(), ...params })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err || "";
      });
  }

  /**
   * @desc 报名接口
   * @param params
   */
  setSignup(params) {
    // post请求，第2个参数作为body参数
    return baseNetwork
      .post(Api.setSignup, { ...getCommonParams(), ...params })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err || "";
      });
  }

  /**
   * @desc 订阅通知
   * @param params
   */
  setSubscription(params) {
    // post请求，第2个参数作为body参数
    return baseNetwork
      .post(Api.setSubscription, { ...getCommonParams(), ...params })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err || "";
      });
  }
  /**
   * @desc 查询帖子列表
   * @param params
   */
  getPostListByActivity(params) {
    return baseNetwork
      .get(Api.getPostListByActivity, { ...getCommonParams(), ...params })
      .then(
        (res) => {
          return res.data;
        },
        (err) => {
          return err || "";
        },
      );
  }
  /**
   * @desc 获得活动所在的合集的所有活动id
   * @param params
   */
  getActIds(params) {
    return baseNetwork
      .get(Api.getActIds, { ...getCommonParams(), ...params })
      .then(
        (res) => {
          return res.data;
        },
        (err) => {
          return err || "";
        },
      );
  }

  /**
   * @desc 查询榜单列表
   * @param params
   */
  getRankList(params) {
    // post请求，第2个参数作为body参数
    return baseNetwork
      .post(Api.getRankList, { ...getCommonParams(), ...params })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err || "";
      });
  }
}

export default new service();
